/* eslint-disable */
import type { TransportTicketPickerActions, TransportTicketPickerStore } from '../types/context/TransportTicketPickerContext';

export enum Types {
    UpdateLanguage = 'UpdateLanguage',
    UpdateTransportMode = 'UpdateTransportMode',
    UpdateCardSupport = 'UpdateCardSupport',
}

export const transportTicketPickerReducer = (state: TransportTicketPickerStore, action: TransportTicketPickerActions) => {
    switch (action.type) {
        case Types.UpdateLanguage:
            return {
                ...state,
                language: action.payload.language,
            };
        case Types.UpdateTransportMode:
            return {
                ...state,
                transportMode: action.payload.transportMode,
            };
        case Types.UpdateCardSupport:
            return {
                ...state,
                cardSupportList: action.payload.cardSupportList,
            };
        default:
            return state;
    }
};
